import {
  Banner,
  BannerVariant,
  BannerStatus,
  BannerLeftAccessoryType,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

export const SsoNotAvailableMessage = () => (
  <Banner
    variant={BannerVariant.Light}
    leftAccessory={{
      type: BannerLeftAccessoryType.Status,
      status: BannerStatus.Warning,
    }}
    title={<Trans>SSO is not available for this email address</Trans>}
  >
    <Trans>
      Please try signing in with a password, or contact your Single Sign On
      administrator.
    </Trans>
  </Banner>
);
